/** @file Scales the alpha byte of a packed straight-alpha colour. */

/** Returns `light` with its alpha multiplied by `factor` (clamped to 0..1), rounded to a byte. */
export function scaleAlpha(light: number, factor: number): number {
  const f = Math.min(1, Math.max(0, Number.isFinite(factor) ? factor : 0));
  return ((light & 0xffffff) | (Math.round((light >>> 24) * f) << 24)) >>> 0;
}
